import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import React, { Component, createRef } from 'react';
import { DateRangePicker } from 'react-date-range';
import { th, enUS } from 'date-fns/locale';
import { addDays } from 'date-fns';
import { bookingStartDate, defaultStay, startOfDay, stayPayload } from './bookingDates';

const thaiMonths = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
  'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
  'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
];

const englishMonths = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const customEnglishLocale = {
  ...enUS,
  localize: {
    ...enUS.localize,
    day: (n) => {
      const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
      return days[n];
    },
  },
};

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.state = this.getInitialState();
    this.closeModal = this.closeModal.bind(this);
    this.calendarRef = createRef();
  }

  getInitialState() {
    const { from, to } = defaultStay(this.props.openingDate);
    const langThai = document.querySelector('html[lang="th"]');

    return {
      focusedRange: [0,0],
      selectedDays: [
        { 
          startDate: from, 
          endDate: to,
          key: 'selection' 
        }
      ],
      from,
      to,
      enteredTo: to,
      dateValue: !langThai ? `${this.formatDate(from)}${" ".repeat(5)}⎯⎯⎯${" ".repeat(5)}${this.formatDate(to)}`
                              : `${this.formatDateThailan(from)}${" ".repeat(5)}⎯⎯⎯${" ".repeat(5)}${this.formatDateThailan(to)}`,
    };
  }

  handleInputFocus = (e) => {
    this.setState({
      showCalendar: true,
      hideCalendar: false,
    });
  }

  closeModal = (e) => {
    this.setState({
      showCalendar: false
    });
  }

  formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  formatDateThailan = (date) => {
    return date.toLocaleDateString("th-TH", {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  handleDayClick = (ranges) => {
    const { selection } = ranges;
    let { startDate, endDate } = selection;
    const { from, to } = this.state;
    if (this.state.focusedRange[1] === 1 && startDate && endDate && startDate.getTime() === endDate.getTime()) {
      endDate = addDays(startDate, 1);
    }
    
    // if (from && to && from.getTime() !== to.getTime()) {
    //   const clickedTime = startDate.getTime();
    //   const fromTime = from.getTime();
    //   const toTime = to.getTime();
      
    //   if (clickedTime >= fromTime && clickedTime <= toTime ) {
    //     this.handleResetClick();
    //     return;
    //   }
    // }
    // if (from && to && startDate < from) {
    //     this.setState({
    //       from: startDate,
    //       to: startDate,
    //       enteredTo: startDate,
    //     });
    //   return;
    // }
    // if (this.isSelectingFirstDay(from, to, startDate)) {
    //   this.setState({
    //     from: startDate,
    //     to: null,
    //     enteredTo: null,
    //   });
    // }
    // if(from && to && from.getTime() !== to.getTime() && from === startDate) {
    //   this.setState({
    //     from: startDate,
    //     to: startDate,
    //     hideCalendar: true,
    //     showCalendar: false,
    //     enteredTo: null,
    //   });
    //   return;
    // }
    
    this.setState({
      selectedDays: [
        { 
          startDate,
          endDate,
          key: 'selection' 
        }
      ],
    });
    if (this.state.focusedRange[1] === 1 && startDate.getTime() < endDate.getTime()){
      const langThai = document.querySelector('html[lang="th"]');
      const selectedDate = !langThai ?
                        this.formatDate(startDate) + " " + " " + "  ⎯⎯⎯⎯  " + " " + " " + this.formatDate(endDate) 
                        : this.formatDateThailan(startDate) + " " + " " + "  ⎯⎯⎯⎯  " + " " + " " + this.formatDateThailan(endDate);


      const timeDiff  = (new Date(endDate)) - (new Date(from));
        const nbdays  = timeDiff / (1000 * 60 * 60 * 24)
        let dateObj = {
          frommonth : new Date(startDate).getMonth() + 1,
          fromday : new Date(startDate).getDate(),
          fromyear: new Date(startDate).getFullYear(),
          tomonth : new Date(endDate).getMonth() + 1,
          dayto : new Date(endDate).getDate(),
          toyear: new Date(endDate).getFullYear(),
          nbdays : nbdays,
        }
      this.props.setCalendarData(dateObj);
      
      this.setState({
        dateValue: selectedDate,
        from: startDate,
        to: endDate,
        enteredTo: endDate,
        hideCalendar: true,
        showCalendar: false,
      });
    }      
  }
  
  handleResetClick() {
    this.setState(this.getInitialState());
  }

  handleClickOutside = event => {
    if (this.calendarRef.current && !this.calendarRef.current.contains(event.target) && this.state.showCalendar) {
      const { selectedDays } = this.state;
      if (selectedDays[0].startDate === selectedDays[0].endDate) {
        this.setState({
          focusedRange: [0,0],
          selectedDays: [
            { 
              startDate: this.state.from, 
              endDate:  this.state.to,
              key: 'selection' 
            }
          ],
        })
      }
      this.setState({ showCalendar: false });
    }
  }

  handleCalendarIconClick = () => {
    this.setState({
      showCalendar: false
    });
  }

  publishStay(from, to) {
    if (this.props.setCalendarData) {
      this.props.setCalendarData(stayPayload(from, to));
    }
  }

  applyRange(from, to) {
    const langThai = document.querySelector('html[lang="th"]');
    const dateValue = !langThai
      ? `${this.formatDate(from)}${" ".repeat(5)}⎯⎯⎯${" ".repeat(5)}${this.formatDate(to)}`
      : `${this.formatDateThailan(from)}${" ".repeat(5)}⎯⎯⎯${" ".repeat(5)}${this.formatDateThailan(to)}`;
    this.setState({
      focusedRange: [0, 0],
      selectedDays: [{ startDate: from, endDate: to, key: 'selection' }],
      from,
      to,
      enteredTo: to,
      dateValue,
    });
    this.publishStay(from, to);
  }

  alignRangeToOpeningDate() {
    const { from, to } = defaultStay(this.props.openingDate);
    this.applyRange(from, to);
  }

  componentDidMount = () => {
    document.addEventListener('click', this.handleClickOutside);
    this.publishStay(this.state.from, this.state.to);
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.openingDate !== this.props.openingDate) {
      this.alignRangeToOpeningDate();
    }
    if (this.state.showCalendar && !prevState.showCalendar) {
      this.updateMonthHeaders();
    }
  }

  updateMonthHeaders = (date) => {
    const langThai = document.querySelector('html[lang="th"]');
    const el = this.calendarRef.current;
    if (!el) return;

    const monthElements = el.querySelectorAll('.rdrMonths .rdrMonthName');
    monthElements.forEach((element, index) => {
          element.classList.add('hide');

    })
    setTimeout(() => {
      
      monthElements.forEach((element, index) => {
        element.classList.remove('hide');
        let currentMonth = date ? new Date(date) : new Date(this.state.from);

        currentMonth.setMonth(currentMonth.getMonth() + index);
        
        const year = currentMonth.getFullYear();
        const monthIndex = currentMonth.getMonth();
        
        if (langThai) {
          const thaiYear = year + 543;
          const monthName = thaiMonths[monthIndex];
          element.textContent = `${monthName} ${thaiYear}`;
        } else {
          const monthName = englishMonths[monthIndex];
          element.textContent = `${monthName} ${year}`;
        }
      });
    }, 50);
  }

  customNavigatorRenderer = (focusedDate, changeShownDate, props) => {
    const langThai = document.querySelector('html[lang="th"]');
    const year = focusedDate.getFullYear();
    const monthIndex = focusedDate.getMonth();
    
    let displayText;
    if (langThai) {
      const thaiYear = year + 543;
      const monthName = thaiMonths[monthIndex];
      displayText = `${monthName} ${thaiYear}`;
    } else {
      const monthName = englishMonths[monthIndex];
      displayText = `${monthName} ${year}`;
    }
    
    return (
      <div className="rdrMonthAndYearWrapper">
        <button 
          type="button" 
          className="rdrNextPrevButton rdrPprevButton"
          onClick={() => changeShownDate(-1, 'monthOffset')}
        >
          <i></i>
        </button>
        <span className="rdrMonthAndYearPickers">
          <span className="rdrMonthPicker">
            <span className="rdrMonthName">{displayText}</span>
          </span>
        </span>
        <button 
          type="button" 
          className="rdrNextPrevButton rdrNextButton"
          onClick={() => changeShownDate(+1, 'monthOffset')}
        >
          <i></i>
        </button>
      </div>
    );
  }
  render() {
    const { from, to, selectedDays, focusedRange } = this.state;
    const langThai = document.querySelector('html[lang="th"]');
    

    let calendarContent;
    calendarContent = <DateRangePicker 
        ranges={selectedDays}
        onChange={this.handleDayClick}
        minDate={bookingStartDate(this.props.openingDate)}
        direction="horizontal"
        showPreview={true}
        showSelectionPreview={true}
        locale={langThai ? th : customEnglishLocale}
        monthDisplayFormat="MMMM yyyy"
        months={2}
        showMonthAndYearPickers={false}
        showDateDisplay={false}
        editableDateInputs={false}
        weekStartsOn={1}
        preventSnapRefocus
        navigatorRenderer={this.customNavigatorRenderer}
        onShownDateChange={(date) => {
          this.updateMonthHeaders(date);
        }}
        focusedRange={focusedRange}
        onRangeFocusChange={(range) => this.setState({focusedRange: range})}
      />

    return (

      <div ref={this.calendarRef} className={' ' + (this.state.showCalendar ? 'mobile-modal-calendar active' : ' ') + (this.state.dateValue ? " has-value" : "")}>
        <input type="text"
        className="dates DayPicker-input-box"
        onFocus={this.handleInputFocus}
        placeholder={ Drupal.t('Check-in Date        ⎯⎯⎯⎯       Check-out Date') }
        onChange={this.handleInputFocus}
        value = {this.state.dateValue || ""}
        readOnly
        />
        <span className="calender-icon" onClick={this.handleCalendarIconClick}></span>
        <label className="check-in">{Drupal.t("Check-in Date")}</label>
        <label className="check-out">{Drupal.t("Check-out Date")}</label>
        <div className={'calender-wrapper calender-custom-wrapper mobile-modal' + (this.state.hideCalendar ? 'mobile-only' : ' ')}>
          <div className="close-btn mobile-only" onClick={this.closeModal}></div>
          <div className="mobile-info-wrapper mobile-only">
            <div className="check-in">
              { Drupal.t('check-in')}
              <div className="form-mobile">
                <div className="num">
                  {
                    from && to &&
                      `${from.toLocaleDateString("en-GB", {day: "numeric"})}`
                  }
                </div>
                <div className="mnth">
                {
                  from && to &&
                  `${from.toLocaleDateString("en-GB", {month: "short"})} ( ${from.toLocaleDateString("en-GB", {weekday: "short"})})`

                }
                </div>
              </div>
            </div>
          </div>
          {calendarContent}
          <div className="done-button btn--primary mobile-only" onClick={this.closeModal}> {Drupal.t("Done")}</div>
        </div>
      </div>
    );
  }
}

export default Calendar;
